import React from 'react';
import { FormLabel, FormControl, IconButton, Tooltip } from '@material-ui/core';
import ClearIcon from '@mui/icons-material/Clear';
import type { FieldArrayMetaProps } from 'redux-form';

import FileUpload from 'retired/FileUpload';
import { gray3, lightGray } from 'utils/color-styles';

const FormFileUpload = ({
  name,
  input,
  labelText,
  uploadCta,
  meta,
  compact,
  acceptedTypes,
  withCrop,
  cropRatio,
  fixed = false,
  imagePreview,
  linkPreview,
  maxSize,
  quality,
  contentDisposition,
  allowClear = false,
  round = false,
  isZoomable = false,
  s3Acl,
  s3Bucket,
}: FormFileUploadProps) => {
  const error = () => (
    <FormLabel error style={{ fontSize: 12, marginTop: 5 }}>
      {meta.error}
    </FormLabel>
  );
  return (
    <FormControl style={{ display: 'block' }}>
      <p style={{ fontSize: 11, color: gray3, marginBottom: 25 }}>{labelText}</p>
      <div style={{ display: 'flex', flexDirection: 'row', position: 'relative' }}>
        {input.value && (
          <>
            {imagePreview && (
              <div
                style={{
                  width: '49%',
                  height: compact ? 100 : 250,
                  marginRight: '2%',
                  position: 'relative',
                  textAlign: 'center',
                }}
              >
                <img
                  style={{
                    objectFit: 'contain',
                    width: round ? (compact ? 100 : 250) : '100%',
                    height: '100%',
                    border: round ? `1px solid ${lightGray}` : 'none',
                    borderRadius: round ? 999 : 0,
                  }}
                  src={input.value}
                  alt=""
                />
              </div>
            )}
            {linkPreview && (
              <div style={{ width: '49%' }}>
                <p>Your document was uploaded successfully</p>
                <br />
                <a href={`${input.value}?download=false`} target="_blank">
                  View your document
                </a>
              </div>
            )}
            {allowClear && (
              <div
                style={{
                  position: 'absolute',
                  top: -24,
                  left: 0,
                }}
              >
                <Tooltip title="Clear">
                  <IconButton onClick={() => input.onChange('')}>
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </>
        )}
        <div
          style={{
            width: imagePreview || linkPreview ? '49%' : '100%',
            height: compact ? 200 : 250,
            position: 'relative',
          }}
        >
          <FileUpload
            name={name}
            onFinish={({ publicUrl }) => input.onChange(publicUrl)}
            acceptedTypes={acceptedTypes}
            withCrop={withCrop}
            cropRatio={cropRatio}
            fixed={fixed}
            maxSize={maxSize}
            quality={quality}
            contentDisposition={contentDisposition}
            isZoomable={isZoomable}
            uploadCta={uploadCta}
            s3Acl={s3Acl}
            s3Bucket={s3Bucket}
          />
        </div>
      </div>
      {meta.dirty && meta.error && error()}
    </FormControl>
  );
};

type FormFileUploadProps = {
  name?: string;
  input: {
    value: string;
    onChange: (value: string) => void;
  };
  meta: Partial<FieldArrayMetaProps>;
  labelText?: string;
  uploadCta?: string;
  acceptedTypes: string | string[];
  compact?: boolean;
  withCrop?: boolean;
  fixed?: boolean;
  cropRatio?: number;
  imagePreview?: boolean;
  linkPreview: boolean;
  maxSize?: number;
  quality?: number;
  contentDisposition: string;
  allowClear?: boolean;
  round?: boolean;
  isZoomable?: boolean;
  s3Acl?: 'private' | 'public';
  s3Bucket?: 'primary' | 'secure';
};

export default FormFileUpload;
